module.exports = __webpack_public_path__ + "static/media/about-strength-01.51e53267.png";